import React from "react";

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; 2025 Technophilia 3.0. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
